import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading } from "../../Styles/style";
import reflect from "../../../assets/images/stelth.png"
import commfoc from "../../../assets/images/verified.png"
import lock from "../../../assets/images/lock.png"

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
justify-content: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`
background:linear-gradient(180deg, #FF33BE, #E31CA4);
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
  height:370px;
border-radius:10px;
`

const SectionWrapper = styled.div`
clip-path: polygon(0 0, 100% 0, 100% 81%, 97% 100%, 4% 100%, 0 81%);
background:linear-gradient(180deg, #000, #1E1E1E);
border:none;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "red")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};
border-top:${(props) => (props.bt ? props.bt : "")};
  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "30px 0")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`;

const SectionSubHeadingSpan = styled.span`
  font-family: "P-B";
  
  text-shadow:0px 0px 10px rgba(255, 255, 255, 0.223);
  background: -webkit-linear-gradient(15deg,#FFDC00, #E58E2F, #DB2D72,#FF00FF );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => (props.fs ? props.fs : "43px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "20px 0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  @media screen and (max-width: 1199px) {
    /* font-size: 30px; */
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;

const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="8rem 0 " p799="0" p599="0" id="About">
        <Container maxWidth="xl">
            <SectionSubHeading
            align="center"
            p="30px 0"
            m="0"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >About <SectionSubHeadingSpan>BabyHex</SectionSubHeadingSpan> <br/>             
          And Why You Should Invest.
          </SectionSubHeading>
          <GridHEading container spacing={3}>
          <Grid item xs={12} lg={12} xl={11.5}>
          <P align="CENTER"  data-aos="flip-up"
                  data-aos-easing="ease-in"
                  data-aos-delay="500"
                  data-aos-duration="500"
                  data-aos-offset="0"
                  href="/"
                  target="_blank">
          Investing in Baby Hex on the Pulse Chain presents an exciting opportunity to participate in a promising blockchain project. Baby Hex combines the trusted infrastructure of Pulse Chain with innovative features designed to maximize returns and provide a secure investment environment. By investing in Baby Hex, you can take advantage of the potential for long-term growth and the unique benefits offered by the Pulse Chain ecosystem. With a dedicated team focused on development and a strong community backing, Baby Hex aims to deliver substantial rewards while maintaining transparency and trust.


          </P>
            </Grid> 
            <GridImage item xs={12} md={4} 
            data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="200"
            data-aos-duration="600"
            data-aos-offset="0"
            >
             <FeatureWrapper>
              <JOiningLinks src={reflect}   data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSmallHeading   
            data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0">Stealth Launch</SectionSmallHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
           Experience the excitement of a stealth launch, where early investors have the opportunity to join a ground-floor project with tremendous growth potential.
            </P></FeatureWrapper>
              
           
            </GridImage>
            <GridImage item xs={12} md={4}  data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="300"
            data-aos-duration="500"
            data-aos-offset="0">
             <FeatureWrapper>
              <JOiningLinks src={commfoc} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSmallHeading data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0">Contract Verified</SectionSmallHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
             Users can rest assured with Baby Hex on the Pulse Chain, our smart contract is verified, ensuring transparency and security for all investors.
              </P>
              
           </FeatureWrapper>
            </GridImage>
            <GridImage item xs={12} md={4}  data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="500"
            data-aos-offset="0">
             <FeatureWrapper>
              <JOiningLinks src={lock} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSmallHeading data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0">Liquidity Locked</SectionSmallHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
          Baby Hex features locked liquidity, providing stability and confidence as you navigate the dynamic cryptocurrency market.
           </P>
           </FeatureWrapper>
            </GridImage>
          
          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
